export default "__VITE_ASSET__c981d928__"